<template>
  <div class="p-other">
    <other
      :items="items"
    ></other>
  </div>
</template>

<script>
import Other from "@/components/ui/Other";

export default {
  components: {Other},
  data() {
    return {
      items: [
        {
          label: this.$t('msg.curator'),
          to: {name: 'curator'},
          icon: 'mdi-account-card',
          bgColor: '#ff8d0021',
          color: '#ff8d00',
          show: this.$vuetify.breakpoint.xsOnly,
        },
        {
          label: this.$t('msg.telegramBot'),
          to: {name: 'telegram_bot'},
          img: '/images/icons/telegram-blue.svg',
          bgColor: 'rgb(0 133 204 / 19%)',
        },
        {
          label: this.$t('msg.markers'),
          to: {name: 'markers'},
          icon: 'mdi-marker',
          bgColor: 'rgba(175,6,6,0.13)',
          color: '#a60404',
        },
        {
          label: this.$t('msg.profile'),
          to: {name: 'profile'},
          icon: 'mdi-account',
          bgColor: 'rgba(131,146,181,0.25)',
          color: '#8392b5',
        },
      ],
    };
  },
}
</script>